module.exports = __webpack_public_path__ + "static/media/great-job-mobile.7aa47efd.png";